import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClipboardScoreGoalReachedColored(
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg ref={ref} viewBox="0 0 90 89" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_100_6581"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="3"
        width="85"
        height="85"
      >
        <path
          d="M37.7959 9.68457C43.207 4.27367 51.9805 4.27366 57.3916 9.68457L58.3047 10.5986C60.2738 12.5677 62.9447 13.6738 65.7295 13.6738H65.9619C73.6144 13.6738 79.8184 19.8778 79.8184 27.5303V27.7627C79.8184 30.5475 80.9244 33.2184 82.8936 35.1875L83.8066 36.1006C89.2178 41.5117 89.2178 50.2852 83.8066 55.6963L82.8936 56.6094C80.9244 58.5785 79.8184 61.2494 79.8184 64.0342V64.2666C79.8184 71.9191 73.6144 78.123 65.9619 78.123H65.7295C62.9447 78.123 60.2738 79.2291 58.3047 81.1982L57.3916 82.1113C51.9805 87.5225 43.207 87.5225 37.7959 82.1113L36.8828 81.1982C34.9137 79.2291 32.2428 78.123 29.458 78.123H29.2256C21.5731 78.123 15.3691 71.9191 15.3691 64.2666V64.0342C15.3691 61.2494 14.2631 58.5785 12.2939 56.6094L11.3799 55.6963C5.96898 50.2852 5.96898 41.5117 11.3799 36.1006L12.2939 35.1875C14.2631 33.2184 15.3691 30.5475 15.3691 27.7627V27.5303C15.3691 19.8778 21.5731 13.6738 29.2256 13.6738H29.458C32.2428 13.6738 34.9137 12.5677 36.8828 10.5986L37.7959 9.68457Z"
          fill="url(#paint0_linear_100_6581)"
          stroke="#9ED79D"
          strokeWidth="3.35598"
        />
      </mask>
      <g mask="url(#mask0_100_6581)">
        <path
          d="M37.7959 9.68457C43.207 4.27367 51.9805 4.27366 57.3916 9.68457L58.3047 10.5986C60.2738 12.5677 62.9447 13.6738 65.7295 13.6738H65.9619C73.6144 13.6738 79.8184 19.8778 79.8184 27.5303V27.7627C79.8184 30.5475 80.9244 33.2184 82.8936 35.1875L83.8066 36.1006C89.2178 41.5117 89.2178 50.2852 83.8066 55.6963L82.8936 56.6094C80.9244 58.5785 79.8184 61.2494 79.8184 64.0342V64.2666C79.8184 71.9191 73.6144 78.123 65.9619 78.123H65.7295C62.9447 78.123 60.2738 79.2291 58.3047 81.1982L57.3916 82.1113C51.9805 87.5225 43.207 87.5225 37.7959 82.1113L36.8828 81.1982C34.9137 79.2291 32.2428 78.123 29.458 78.123H29.2256C21.5731 78.123 15.3691 71.9191 15.3691 64.2666V64.0342C15.3691 61.2494 14.2631 58.5785 12.2939 56.6094L11.3799 55.6963C5.96898 50.2852 5.96898 41.5117 11.3799 36.1006L12.2939 35.1875C14.2631 33.2184 15.3691 30.5475 15.3691 27.7627V27.5303C15.3691 19.8778 21.5731 13.6738 29.2256 13.6738H29.458C32.2428 13.6738 34.9137 12.5677 36.8828 10.5986L37.7959 9.68457Z"
          fill="url(#paint1_linear_100_6581)"
          stroke="#9ED79D"
          strokeWidth="3.35598"
        />
        <g filter="url(#filter0_f_100_6581)">
          <path
            d="M136.941 39.2353L153.599 53.5884L58.6539 135.78L41.9957 121.427L136.941 39.2353Z"
            fill="#E8F9E1"
          />
        </g>
        <g filter="url(#filter1_f_100_6581)">
          <path
            d="M165.386 59.4775L171.941 65.126L76.9966 147.318L70.441 141.67L165.386 59.4775Z"
            fill="#E8F9E1"
          />
        </g>
        <path
          d="M33.8906 50.5125L42.1128 59.3219L61.2978 35.8301"
          stroke="url(#paint2_linear_100_6581)"
          strokeWidth="8.54507"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M10.1102 1.9362C10.1102 1.56801 9.81177 1.26953 9.44358 1.26953C9.07539 1.26953 8.77691 1.56801 8.77691 1.9362C8.77691 4.70976 8.16476 6.55461 7.00226 7.71711C5.83976 8.87961 3.99491 9.49175 1.22135 9.49175C0.853164 9.49175 0.554688 9.79023 0.554688 10.1584C0.554688 10.5266 0.853164 10.8251 1.22135 10.8251C3.99491 10.8251 5.83976 11.4372 7.00226 12.5997C8.16476 13.7622 8.77691 15.6071 8.77691 18.3806C8.77691 18.7488 9.07539 19.0473 9.44358 19.0473C9.81177 19.0473 10.1102 18.7488 10.1102 18.3806C10.1102 15.6071 10.7224 13.7622 11.8849 12.5997C13.0474 11.4372 14.8922 10.8251 17.6658 10.8251C18.034 10.8251 18.3325 10.5266 18.3325 10.1584C18.3325 9.79023 18.034 9.49175 17.6658 9.49175C14.8922 9.49175 13.0474 8.87961 11.8849 7.71711C10.7224 6.55461 10.1102 4.70976 10.1102 1.9362Z"
        fill="#0D2B57"
      />
      <defs>
        <filter
          id="filter0_f_100_6581"
          x="33.9961"
          y="31.2344"
          width="127.603"
          height="112.547"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_100_6581" />
        </filter>
        <filter
          id="filter1_f_100_6581"
          x="62.4414"
          y="51.4766"
          width="117.5"
          height="103.842"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_100_6581" />
        </filter>
        <linearGradient
          id="paint0_linear_100_6581"
          x1="30.2266"
          y1="7.30469"
          x2="47.5937"
          y2="84.4922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_100_6581"
          x1="30.2266"
          y1="7.30469"
          x2="47.5937"
          y2="84.4922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_100_6581"
          x1="38.4585"
          y1="38.7666"
          x2="45.404"
          y2="60.0371"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#094534" />
          <stop offset="1" stopColor="#4D9863" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgClipboardScoreGoalReachedColored);
export default ForwardRef;
